import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { AIAssistant } from "@/components/AIAssistant";
import { MobileConversionBar } from "@/components/MobileConversionBar";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import Requests from "@/pages/Requests";
import Home from "@/pages/Home";
import Collections from "@/pages/Collections";
import ProductDetail from "@/pages/ProductDetail";
import Consultation from "@/pages/Consultation";
import About from "@/pages/About";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/about" element={<About />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalArticle />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/analytics" element={<AnalyticsDashboard />} />
            <Route path="/requests" element={<Requests />} />
          </Routes>
        </main>
        <Footer />
        <AIAssistant />
        <MobileConversionBar />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#EFE8DC",
              border: "1px solid rgba(197,162,77,0.35)",
              color: "#262019",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
